import Input from "@/atoms/Input";
import Button from "@/atoms/Button";
import { useState, useEffect, useRef } from "react";
import { useMutation } from "react-query";
import { addToWaitlist } from "@/services/api";
import { AxiosError } from "axios";
import { useSignUp } from "@/contexts/SignUpContext";
import { conversionSubmitLeadForm } from "@/components/shared/gtm";
import Link from "next/link";

const DownloadBanner = (): JSX.Element => {
  const { signUpViewRef } = useSignUp();

  useEffect(() => {
    if (window.location.hash === "#download") {
      setTimeout(() => {
        if (signUpViewRef.current) {
          signUpViewRef.current.scrollIntoView({ behavior: "auto" });
        }
      }, 600);
    }
  }, [signUpViewRef]);

  const DownloadButton = () => {
    return (
      <Button
        variant="primary"
        className="border-none transform hover:scale-105 rounded-full text-white w-full md:w-26 h-14 md:h-13 font-bold"
      >
        <Link href="/download">Download Klink</Link>
      </Button>
    );
  };

  return (
    <section
      className="px-5 lg:px-11 xl:px-32 overflow-hidden"
      ref={signUpViewRef}
    >
      <div className="relative w-full flex justify-center items-center h-[30rem] md:h-[26rem] bg-gradient-to-tr from-navy from-50% md:from-55% to-magenta to-110% bg-navy rounded-3xl">
        <div
          className="absolute w-[300px] h-[300px] md:w-[30rem] md:h-[30rem] -bottom-[2rem] -left-3 md:-bottom-[10rem] md:-left-6"
          style={{
            background:
              "radial-gradient(50% 50% at 50% 50%, #2233FD 0%, rgba(34, 51, 253, 0.00) 100%)",
          }}
        ></div>

        <div className="w-full flex flex-col gap-8 text-center md:px-20 px-4 z-50">
          <h3 className="text-2xl lg:text-4xl text-white font-bold">
            Ready to start your home buying journey?
          </h3>
          <div className="flex flex-col md:flex-row justify-center gap-3 md:gap-5">
            <div className="hidden md:block">
              <DownloadButton />
            </div>

            <div className="md:hidden w-full flex justify-center">
              <DownloadButton />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadBanner;
